import { ShieldCheck } from 'lucide-react';

/**
 * Discreet trust-builder: shows that payment is processed by the external
 * pimentadocelingerie.pt partner. Used next to Premium CTAs to create
 * confidence BEFORE the webhook integration is live.
 *
 * Props:
 *  - variant: 'dark' (on red/ruby gradients, used in Home banners)
 *             | 'default' (on the standard page background)
 *  - className: extra tailwind classes
 */
export default function PaymentTrust({ variant = 'default', className = '' }) {
  const base =
    variant === 'dark'
      ? 'text-white/70 hover:text-white'
      : 'text-muted-foreground hover:text-foreground';

  return (
    <a
      href="https://www.pimentadocelingerie.pt"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abre pimentadocelingerie.pt em nova aba"
      data-testid="payment-trust-link"
      className={`inline-flex items-center gap-1.5 text-[11px] font-medium transition-colors ${base} ${className}`}
    >
      <ShieldCheck className="w-3 h-3" />
      <span>
        Pagamento seguro processado em{' '}
        <span className="underline underline-offset-2">
          pimentadocelingerie.pt
        </span>
      </span>
    </a>
  );
}
